import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-exemplos',
  templateUrl: './exemplos.component.html',
  styleUrls: ['./exemplos.component.scss']
})

export class ExemplosComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
